<template>
    <td
        role="cell"
        :style="containerStyle"
        :class="containerClass"
        @click="setFocus"
        :data-p-frozen-column="frozen"
        :data-p-editable-column="editableCell"
    >
        <div class="md-editable-grid-cell-wrapper" @dblclick="onCellDblClick">
            <!-- Editing mode -->
            <div
                v-if="isEditing"
                :class="{
                    'md-editable-grid-cell-content-invalid': invalid,
                    'md-editable-grid-cell-editing': !invalid
                }"
                class="md-editable-grid-cell-content"
                contenteditable="true"
                ref="inputRef"
                @keydown="handleKeydown"
                @blur="finishEdit"
            >
                {{ value }}
            </div>

            <!-- Display mode -->
            <span
                v-else
                class="md-editable-grid-cell-display"
                :class="{ 'md-editable-grid-cell-non-editable': !editable }"
                @dblclick="requestEdit"
                @keydown="handleDisplayKeydown"
                tabindex="0"
                ref="displayRef"
            >
                {{ valueFormatted }}
            </span>

            <!-- Search icon -->
            <i
                v-if="showSearchIcon && isEditing"
                class="fas fa-search editable-input-cell-search-icon"
            ></i>
        </div>
    </td>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import EditableCellBase from './EditableCellBase.vue';

export default {
    name: 'EditableInputCell',
    mixins: [ShowMessage],
    inject: ['$parentInstance'],
    extends: EditableCellBase,
    props: {
        value: [String, Number],
        showSearchIcon: { type: Boolean, default: false }
    },
    methods: {
        startEdit(char) {
            if (!this.editableCell) {
                this.displayContentFocus();
                return;
            }

            this.isEditing = true;
            if (char !== undefined) {
                this.$nextTick(() => {
                    const el = this.$refs.inputRef;
                    if (el) {
                        el.innerText = char;
                        el.focus();
                        this.moveCaretToEnd(el);
                    }
                });
            } else {
                this.inputContentFocus();
            }
        },
        finishEdit(event) {
            if (this.isEditing) {
                this.isEditing = false;
                const val = event.target.innerText.trim();
                const changed = val !== String(this.value).trim();

                const valid = this.validateCell(val);
                if (changed) {
                    if (this.isAppendSection) {
                        this.$emit('input', val);
                    } else {
                        this.$parentInstance.cellEditComplete(this.createEventData(val));
                    }
                }

                if (!valid) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.invalidMessage(this.name),
                        'errorAutoHide'
                    );
                }
            }
        }
    }
};
</script>

<style scoped>
.editable-input-cell-search-icon {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: #007bff;
    pointer-events: none;
}
</style>
